/* RVA Threads: Get a Quote beside Add to request on the product (style) pages. Oct 23 2026.
   J: "Do you think each product page should have a get a quote button next to add to button ... i want this to be
   user friendly." Loaded by sections/rva-quote-now.liquid on the style, catalog and request pages.
   Product page:
   - Get a Quote (filled) sits beside Add to request (outlined), the same size, on phones and desktop.
   - Sizes or a total entered: adds them to the request and opens the send step on /pages/your-request, the same
     send step as the request page's own Get a Quote (recap, name, email, artwork, thank-you page after).
   - Nothing entered: opens /pages/get-a-quote with the shirt and color in the Product Breakdown box (J asks for
     sizes himself), plus the print colors if the customer changed them from a 1-color front.
   - Under the 12-piece minimum for the whole order: says so under the buttons and stays on the page.
   Request page: when a product page sent the customer here (sessionStorage rvaQuoteNow), opens the send step on
   arrival. sections/rva-quote-now.liquid keeps the page hidden until then so the request list does not flash first. */
(function () {
  "use strict";
  if (window.__rvaQuoteNow) return;
  window.__rvaQuoteNow = 1;

  var FLAG = "rvaQuoteNow",
    REQ_URL = "/pages/your-request",
    PLAIN = "/pages/get-a-quote",
    KEY = "rvaThreadsRequest.v1",
    LABEL = "Get a Quote",
    BUSY = "Loading…",
    HINT = "Enter quantities above, or get a quote without sizes.";

  var CSS =
    "html body #rvaCat .addRow.rqnOn{column-gap:12px!important}" +
    "html body #rvaCat .addRow.rqnOn #addBtn,html body #rvaCat .addRow.rqnOn #rqnBtn{flex:1 1 0!important;width:auto!important;min-width:0!important;max-width:260px!important;" +
    "height:52px!important;margin:0!important;padding:0 14px!important;font-size:16px!important;font-weight:700!important;line-height:1.1!important;white-space:nowrap!important;" +
    "border-radius:var(--r,6px)!important;box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;text-align:center!important}" +
    "html body #rvaCat .addRow.rqnOn #addBtn{background:#fff!important;color:var(--cy,#0071e3)!important;border:0!important;box-shadow:inset 0 0 0 2px var(--cy,#0071e3)!important}" +
    "html body #rvaCat .addRow.rqnOn #addBtn:not(:disabled):hover,html body #rvaCat .addRow.rqnOn #addBtn:not(:disabled):focus-visible{background:var(--cy-soft,#e8f2fd)!important}" +
    "html body #rvaCat .addRow.rqnOn #rqnBtn[aria-busy=true]{cursor:progress!important;opacity:.85}" +
    "html body #rvaCat .addRow.rqnOn .addSum{flex:1 1 100%!important}" +
    "#rvaCat .rqnMsg{flex:1 1 100%;margin:0;font-size:13.5px;line-height:1.45;font-weight:700;color:#b8151e}" +
    "#rvaCat .addRow:has(.rqnMsg) .addSum .minNote{display:none}" +
    "@media (max-width:899px){html body #rvaCat .addRow.rqnOn #addBtn,html body #rvaCat .addRow.rqnOn #rqnBtn{max-width:none!important}#rvaCat .rqnMsg{text-align:center}}" +
    "@media (max-width:379px){html body #rvaCat .addRow.rqnOn{column-gap:8px!important}html body #rvaCat .addRow.rqnOn #addBtn,html body #rvaCat .addRow.rqnOn #rqnBtn{padding:0 8px!important;font-size:15px!important}}";

  function $(id) { return document.getElementById(id); }
  function St() { return window.S; }
  function fn(k) { return typeof window[k] === "function"; }
  function isReq() { return !!$("reqPage"); }
  function warn(e) { try { console.warn("rva-quote-now", e); } catch (x) {} }
  function minPcs() { return +window.MIN_PIECES || 12; }
  function inReq() { try { return +window.reqPieces() || 0; } catch (e) { return 0; } }
  function inDraft() {
    try { if (fn("draftPieces")) return +window.draftPieces() || 0; } catch (e) {}
    var S = St(), n = 0;
    if (S && S.draft) for (var k in S.draft) n += +S.draft[k] || 0;
    return n;
  }

  /* ---------- request page: open the send step on arrival ---------- */
  function autoSend() {
    var html = document.documentElement, at = 0;
    try { at = +sessionStorage.getItem(FLAG) || 0; sessionStorage.removeItem(FLAG); } catch (e) {}
    function reveal() { html.classList.remove("rqnGo"); }
    if (!at || Date.now() - at > 120000) { reveal(); return; }
    /* wait for the request page scripts (send step, ZIP, neck tags) to finish setting up, then press its Get a Quote */
    var t0 = Date.now(), upAt = 0;
    (function tick() {
      var s = $("send") || $("sendM"), S = St();
      if (document.readyState !== "loading" && window.rvaF2Ready && window.__rvaFlow2Send && s && S && S.req) {
        if (!upAt) upAt = Date.now();
        if (Date.now() - upAt >= 200) {
          if (!s.disabled && S.req.length) {
            try { s.click(); } catch (e) { warn(e); }
          }
          setTimeout(reveal, 60);
          return;
        }
      }
      if (Date.now() - t0 > 7000) { reveal(); return; }
      setTimeout(tick, 50);
    })();
  }

  if (isReq()) { autoSend(); return; }

  /* ---------- product page ---------- */
  function hint() {
    var t = $("addSum");
    if (!t || inDraft()) return;
    var n = t.firstChild;
    if (n && n.nodeType === 3 && /^Enter quantities/.test(n.nodeValue) && n.nodeValue !== HINT) n.nodeValue = HINT;
  }
  function clearMsg() {
    var m = $("rqnMsg");
    if (m && m.parentNode) m.parentNode.removeChild(m);
  }
  function showMsg(text) {
    var b = $("rqnBtn");
    if (!b) return;
    var m = $("rqnMsg");
    if (!m) {
      m = document.createElement("p");
      m.id = "rqnMsg";
      m.className = "rqnMsg";
      m.setAttribute("role", "alert");
    }
    m.textContent = text;
    if (b.nextElementSibling !== m) b.parentNode.insertBefore(m, b.nextSibling);
  }
  function busy(on) {
    var b = $("rqnBtn");
    if (!b) return;
    b.disabled = !!on;
    b.textContent = on ? BUSY : LABEL;
    if (on) b.setAttribute("aria-busy", "true");
    else b.removeAttribute("aria-busy");
  }

  function ensure() {
    var P = $("panel");
    if (!P) return;
    var add = P.querySelector(".addRow #addBtn");
    if (!add) return;
    var row = add.closest(".addRow"), b = $("rqnBtn");
    if (!b) {
      b = document.createElement("button");
      b.type = "button";
      b.id = "rqnBtn";
      b.className = "btn btn--pri rqnBtn";
      b.textContent = LABEL;
    }
    if (add.nextElementSibling !== b) add.parentNode.insertBefore(b, add.nextSibling);
    if (row && !row.classList.contains("rqnOn")) row.classList.add("rqnOn");
    hint();
  }

  /* Everything J needs reaches him: the line, sizes and estimate go through the request page's own hand-off. */
  function stored() {
    try {
      var t = JSON.parse(localStorage.getItem(KEY) || "null"), n = 0;
      if (!t || !Array.isArray(t.lines)) return false;
      t.lines.forEach(function (l) {
        var z = l && l.sizes || {};
        for (var k in z) n += +z[k] || 0;
      });
      return n === inReq();
    } catch (e) { return false; }
  }
  function fallback() {
    /* the browser would not keep the request (storage blocked): send the same details to the quote form page */
    var u = "";
    try { u = String(window.submitURL() || ""); } catch (e) {}
    var i = u.indexOf("?");
    location.href = PLAIN + (i > -1 ? u.slice(i) : "");
  }
  function plain(st) {
    var S = St(), c = null;
    try { c = window.swatchOf(st); } catch (e) {}
    var line = st.b + " " + st.n + " - " + st.s + (c && c[0] ? " (" + c[0] + ")" : "");
    var q = "sizeBreakdown=" + encodeURIComponent(line);
    var f = +S.front || 0, k = +S.back || 0;
    if (f !== 1 || k) {
      var spec = (f ? "Front " + f + "-color" : "") + (f && k ? ", " : "") + (k ? "Back " + k + "-color" : "");
      if (spec) q += "&printLocations=" + encodeURIComponent(spec);
    }
    busy(true);
    location.href = PLAIN + "?" + q;
  }
  function go() {
    var S = St();
    if (!S || !S.open || !fn("styleById") || !fn("addToRequest")) return;
    var st = window.styleById(S.open);
    if (!st) return;
    var d = inDraft();
    if (!d) { plain(st); return; }
    var min = minPcs(), all = inReq() + d;
    if (all < min) {
      showMsg(min + "-piece minimum for the whole order. Add " + (min - all) + " more in any size, color or style.");
      return;
    }
    clearMsg();
    var before = inReq(), keep = window.showAddToast;
    window.showAddToast = function () {};
    try { window.addToRequest(st); } finally { window.showAddToast = keep; }
    if (inReq() <= before) return;
    try { window.saveReq(); } catch (e) {}
    ensure();
    busy(true);
    if (!stored()) { fallback(); return; }
    try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (e) {}
    location.href = REQ_URL;
  }
  function onClick(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest("#rqnBtn") : null;
    if (!b || b.disabled) return;
    ev.preventDefault();
    try { go(); } catch (e) { warn(e); busy(false); }
  }

  function wrapSum() {
    var f = window.updateAddSum;
    if (typeof f !== "function") return false;
    if (f.rvaQuoteNow) return true;
    var g = function () {
      var r = f.apply(this, arguments);
      try { clearMsg(); hint(); } catch (e) { warn(e); }
      return r;
    };
    for (var k in f) if (Object.prototype.hasOwnProperty.call(f, k)) g[k] = f[k];
    g.rvaQuoteNow = 1;
    window.updateAddSum = g;
    return true;
  }

  var booted = false;
  function boot() {
    if (booted) return true;
    var P = $("panel");
    if (!St() || !P || !fn("addToRequest") || !fn("styleById") || !fn("updateAddSum")) return false;
    booted = true;
    try {
      if (!$("rqnCss")) {
        var s = document.createElement("style");
        s.id = "rqnCss";
        s.textContent = CSS;
        document.head.appendChild(s);
      }
      wrapSum();
      new MutationObserver(function () {
        try { ensure(); } catch (e) { warn(e); }
      }).observe(P, { childList: true, subtree: true });
      ensure();
    } catch (e) { warn(e); }
    return true;
  }

  document.addEventListener("click", onClick);
  window.addEventListener("pageshow", function () {
    /* back from the request page or the quote form (page restored as it was left) */
    try { sessionStorage.removeItem(FLAG); } catch (e) {}
    busy(false);
  });
  if (!boot()) {
    var tries = 0, iv = setInterval(function () {
      if (boot() || ++tries > 200) clearInterval(iv);
    }, 50);
  }
})();